import React, { FunctionComponent } from "react";
import { Variant } from "@bca/ui-library/dist/Typography/typography.type";
import VersionNavigationSpan from "./VersionNavigationSpan";

interface VersionNavigationTextProps {
  variant: Variant;
  isLatestVersion: boolean;
}

const VersionNavigationText: FunctionComponent<VersionNavigationTextProps> = ({
  variant,
  isLatestVersion,
}) => {
  const LatestVersionText = () => (
    <>
      <VersionNavigationSpan fontWeight="400" variant={variant}>
        Some information has been updated since the vehicle was sold. You are
        viewing the{" "}
      </VersionNavigationSpan>
      <VersionNavigationSpan fontWeight="500" variant={variant}>
        latest version{" "}
      </VersionNavigationSpan>
      <VersionNavigationSpan fontWeight="400" variant={variant}>
        of this page.
      </VersionNavigationSpan>
    </>
  );

  const PreviousVersionText = () => (
    <>
      <VersionNavigationSpan fontWeight="500" variant={variant}>
        Some vehicle information has changed.{" "}
      </VersionNavigationSpan>
      <VersionNavigationSpan fontWeight="400" variant={variant}>
        You are viewing an older version of this page from when the vehicle was
        sold.
      </VersionNavigationSpan>
    </>
  );

  return (
    <>{isLatestVersion ? <LatestVersionText /> : <PreviousVersionText />}</>
  );
};

export default VersionNavigationText;
